/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

export class StoreEmail {
  id: number;
  emailType: StoreEmailType;
  email: string;

  constructor() {
    this.id = 0;
    this.emailType = StoreEmailType.work;
    this.email = "";
  }
}

export enum StoreEmailType {
  personal = "Personal",
  work = "Work",
  other = "Other",
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
